import React from "react";
import Logo from "assets/new-hire-logo.png";
import { Card } from "antd";
import { useForgotPasswordContext } from "context/ForgotPasswordEnumeratorContext";
import { useLocation } from "react-router-dom";
import PasswordOtpReuqest from "./components/RequestOtp";
import PasswordOtpVerify from "./components/VerifyOtp";

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = React.useState<string>("");
  const { isEmailSent, isFirstStep } = useForgotPasswordContext();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const queryValue = queryParams.get("roleType");

  return (
    <React.Fragment>
      <div className="h-screen bg-background overflow-auto">
        <div className="max-w-lg mx-auto my-6 ">
          <div className="flex justify-center mb-0">
            <img alt="#" src={Logo} width={350} />
          </div>
          <Card className="px-4 py-6">
            {isFirstStep && (
            <PasswordOtpReuqest setEmail={setEmail} roleType={queryValue} />
            )}
            {isEmailSent && (
              <PasswordOtpVerify email={email} />
            )}
          </Card>
        </div>
      </div>
    </React.Fragment>
  );
};
export default ForgotPassword;
